module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("It’s such a simple thing to make love. "), _c('br'), _vm._v("It’s like being thirsty and drinking. "), _c('br'), _vm._v("Nothing could be simpler than being thirsty and drinking; "), _c('br'), _vm._v("quenching one’s thirst, feeling satisfaction at having done so; "), _c('br'), _vm._v("no longer feeling thirst. Utterly simple. "), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—LEONARDO SCIASCIA")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("One Way or Another")]), _vm._v(" "), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aec08ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/threeimperfect_00001.vue
// module id = 69
// module chunks = 0